<template>
  <section class="methodology" id="methodology">
    <div class="container">
      <h2>{{ $t('methodology.title') }}</h2>
      <p class="subtitle">{{ $t('methodology.subtitle') }}</p>
      <div class="phases">
        <div v-for="(phase, i) in $tm('methodology.phases')" :key="i" class="phase-card">
          <div class="phase-number">{{ i + 1 }}</div>
          <div class="phase-content">
            <h3>{{ phase.title }}</h3>
            <span class="timeline">{{ phase.timeline }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.methodology {
  padding: 80px 20px;
  background-color: var(--gray-light);
}

.container {
  max-width: 900px;
  margin: 0 auto;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  text-align: center;
  color: var(--text-color);
}

.subtitle {
  font-size: 1.1rem;
  max-width: 700px;
  margin: 0 auto 50px;
  text-align: center;
  opacity: 0.8;
  line-height: 1.6;
}

.phases {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.phase-card {
  display: flex;
  align-items: center;
  gap: 24px;
  background: var(--white);
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

.phase-card:hover {
  transform: translateX(8px);
}

.phase-number {
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 800;
}

.phase-content h3 {
  margin: 0 0 6px;
  color: var(--text-color);
  font-size: 1.15rem;
}

.timeline {
  font-size: 0.9rem;
  color: var(--primary-color);
  font-weight: 600;
}

@media (max-width: 768px) {
  .methodology {
    padding: 40px 15px;
  }
  h2 {
    font-size: 1.8rem;
  }
  .phase-card {
    padding: 20px;
    gap: 16px;
  }
}
</style>
